var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _vm.loadingSpinner
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", label: "Spinning" },
            }),
          ],
          1
        )
      : _vm._e(),
    !_vm.loadingSpinner
      ? _c(
          "div",
          [
            _c(
              "b-card",
              { staticClass: "my-2" },
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", [
                      _c("h2", { staticClass: "text-primary m-0 p-0" }, [
                        _vm._v("Product manufactured inhouse?"),
                      ]),
                    ]),
                    _c(
                      "b-col",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-start my-1",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "mr-2 text-primary",
                            attrs: { for: "check-button" },
                          },
                          [_vm._v("No")]
                        ),
                        _c("b-form-checkbox", {
                          attrs: {
                            name: "check-button",
                            switch: "",
                            inline: "",
                            disabled: "",
                          },
                          model: {
                            value: _vm.product.inHouseManufactured,
                            callback: function ($$v) {
                              _vm.$set(_vm.product, "inHouseManufactured", $$v)
                            },
                            expression: "product.inHouseManufactured",
                          },
                        }),
                        _c(
                          "label",
                          {
                            staticClass: "text-primary",
                            attrs: { for: "check-button" },
                          },
                          [_vm._v("Yes")]
                        ),
                      ],
                      1
                    ),
                    _c("b-col", [_c("h3")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.product.inHouseManufactured == true
              ? _c(
                  "form-wizard",
                  {
                    ref: "formWiz",
                    staticClass: "mb-3",
                    attrs: {
                      color: "#B1D06C",
                      title: null,
                      subtitle: null,
                      shape: "square",
                      "finish-button-text": "Finish",
                      "back-button-text": "Previous",
                    },
                    on: { "on-complete": _vm.formSubmitted },
                  },
                  [
                    _c(
                      "tab-content",
                      { attrs: { title: "Details" } },
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Product Name",
                                          "label-for": "mc-Product-name",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Product-name",
                                            type: "text",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.product, "name", $$v)
                                            },
                                            expression: "product.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Product classification",
                                          "label-for": "mc-Product-name",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Product-name",
                                            type: "text",
                                            value: _vm.getTypeNameById(
                                              _vm.product.type
                                            ),
                                            readonly: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "2" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Enable Ecommerce",
                                          "label-for": "mc-Product-Ecomm",
                                        },
                                      },
                                      [
                                        _c("b-form-checkbox", {
                                          attrs: {
                                            checked: "false",
                                            name: "check-button",
                                            switch: "",
                                            inline: "",
                                            disabled: "",
                                          },
                                          model: {
                                            value: _vm.product.isEcomm,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.product,
                                                "isEcomm",
                                                $$v
                                              )
                                            },
                                            expression: "product.isEcomm",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "4" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Product Code",
                                          "label-for": "mc-Product-Code",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Product-Code",
                                            type: "text",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.code,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.product, "code", $$v)
                                            },
                                            expression: "product.code",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Barcode",
                                          "label-for": "mc-Barcode",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Barcode",
                                            type: "text",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.barcode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.product,
                                                "barcode",
                                                $$v
                                              )
                                            },
                                            expression: "product.barcode",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-for": "mc-stock-threshold",
                                          label: "Unit Of Measure",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-label-group" },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "mc-Barcode",
                                                type: "text",
                                                value: _vm.product.uomName,
                                                readonly: "",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-for": "mc-stock-threshold",
                                          label: "Low Stock Threshold",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-label-group" },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "mc-stock",
                                                type: "text",
                                                readonly: "",
                                              },
                                              model: {
                                                value: _vm.product.lowStock,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.product,
                                                    "lowStock",
                                                    $$v
                                                  )
                                                },
                                                expression: "product.lowStock",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-for": "productionCapacity",
                                          label: "Production Capacity",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Product-productionCapacity",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.productionLimit,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.product,
                                                "productionLimit",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "product.productionLimit",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Category",
                                          "label-for": "mc-Category",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Category",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.categoryName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.product,
                                                "categoryName",
                                                $$v
                                              )
                                            },
                                            expression: "product.categoryName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Sub Category",
                                          "label-for": "mc-subCategory",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-subCategory",
                                            value: _vm.product.subCategoryName,
                                            readonly: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "3" } },
                                  [
                                    _c(
                                      "label",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName:
                                              "v-b-tooltip.hover.focus.v-secondary",
                                            modifiers: {
                                              hover: true,
                                              focus: true,
                                              "v-secondary": true,
                                            },
                                          },
                                        ],
                                        attrs: {
                                          title:
                                            "Note: Disabling a product means all current stock will be sent to scrap.",
                                          for: "textarea-default",
                                        },
                                      },
                                      [_vm._v("Enable/Disable Product ")]
                                    ),
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          checked: "true",
                                          readonly: "",
                                          name: "check-button",
                                          switch: "",
                                        },
                                        model: {
                                          value: _vm.product.isActive,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.product,
                                              "isActive",
                                              $$v
                                            )
                                          },
                                          expression: "product.isActive",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.product.isActive
                                                ? "Enabled"
                                                : "Disabled"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c("CustomFieldsDetails", {
                                      attrs: {
                                        ReadOnlyFields: true,
                                        AdditionalFields:
                                          _vm.product.additionalFields,
                                        ModuleReference: "Product",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mb-2",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "textarea-default" } },
                                      [_vm._v("Product Description")]
                                    ),
                                    _c("b-form-textarea", {
                                      attrs: {
                                        id: "textarea-default",
                                        value: "Lorem",
                                        rows: "5",
                                        readonly: "",
                                      },
                                      model: {
                                        value: _vm.product.description,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.product,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "product.description",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  { staticClass: "row mb-2 col-12" },
                                  [
                                    _vm.product.productImage
                                      ? _c(
                                          "b-col",
                                          { attrs: { md: "6" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Product Image",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "d-flex" },
                                                  [
                                                    _c("img", {
                                                      staticClass: "img-fluid",
                                                      staticStyle: {
                                                        "max-height": "130px",
                                                        "max-width": "100%",
                                                        "object-fit": "contain",
                                                      },
                                                      attrs: {
                                                        src:
                                                          "data:image/jpeg;base64," +
                                                          _vm.product
                                                            .productImage,
                                                        width: "250",
                                                        height: "250",
                                                        alt: "Product Image",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.product.barcode
                                      ? _c(
                                          "b-col",
                                          { attrs: { md: "6" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Barcode Preview",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-column ",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        ref: "barcode",
                                                        staticClass: "mb-2",
                                                      },
                                                      [
                                                        _c(
                                                          "barcode",
                                                          {
                                                            staticClass:
                                                              "canva",
                                                            attrs: {
                                                              value:
                                                                _vm.product
                                                                  .barcode,
                                                              format: "CODE128",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Invalid barcode - Barcode cannot be rendered. "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center",
                                                      },
                                                      [
                                                        _c(
                                                          "b-button",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              variant:
                                                                "success",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.downloadBarcode,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Download Barcode "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              variant: "info",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.printBarcode,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Print Barcode "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "tab-content",
                      { attrs: { title: "Bill Of Materials" } },
                      [
                        _c(
                          "b-form",
                          {
                            ref: "form",
                            staticClass: "repeater-form",
                            style: { height: _vm.trHeight },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.repeateAgain($event)
                              },
                            },
                          },
                          _vm._l(_vm.sortBom, function (item, index) {
                            return _c(
                              "b-row",
                              { key: index, attrs: { id: index } },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "3" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label:
                                            "Raw Material / Work In Progress",
                                          "label-for": "Operation-name",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            value: _vm.getMaterialNameById(
                                              item.materialId
                                            ),
                                            readonly: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "2" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Unit of Measure",
                                          "label-for": "cost",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            value: _vm.getUomNameById(
                                              item.itemUomId
                                            ),
                                            readonly: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "2" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Qty",
                                          "label-for": "cost",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "cost",
                                            type: "number",
                                            readonly: "",
                                          },
                                          model: {
                                            value: item.quantity,
                                            callback: function ($$v) {
                                              _vm.$set(item, "quantity", $$v)
                                            },
                                            expression: "item.quantity",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { lg: "2", md: "2" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Total Cost",
                                          "label-for": "price",
                                        },
                                      },
                                      [
                                        _vm.HasPermission(
                                          _vm.PermissionList.Inventory_Finance
                                        )
                                          ? _c("b-form-input", {
                                              attrs: {
                                                id: "price",
                                                readonly: "",
                                              },
                                              model: {
                                                value: item.totalCost,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "totalCost",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.totalCost",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c("b-col", { attrs: { cols: "12" } }, [
                                  _c("hr"),
                                ]),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "tab-content",
                      { attrs: { title: "Pricing" } },
                      [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                              },
                            },
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Cost Price",
                                          "label-for": "h-number",
                                          "label-cols-md": "4",
                                        },
                                      },
                                      [
                                        _vm.HasPermission(
                                          _vm.PermissionList.Inventory_Finance
                                        )
                                          ? _c("b-form-input", {
                                              attrs: {
                                                id: "h-number",
                                                type: "number",
                                                readonly: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.product.purchasePrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.product,
                                                    "purchasePrice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "product.purchasePrice",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label:
                                            "Selling Price (Tax Exclusive)",
                                          "label-for": "h-Selling",
                                          "label-cols-md": "4",
                                        },
                                      },
                                      [
                                        _vm.HasPermission(
                                          _vm.PermissionList.Inventory_Finance
                                        )
                                          ? _c("b-form-input", {
                                              attrs: {
                                                id: "h-Mark",
                                                type: "number",
                                                readonly: "",
                                              },
                                              model: {
                                                value: _vm.product.salePrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.product,
                                                    "salePrice",
                                                    $$v
                                                  )
                                                },
                                                expression: "product.salePrice",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.vat
                                  ? _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: "Sales VAT (%)",
                                              "label-for": "h-Tax",
                                              "label-cols-md": "4",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "h-Mark",
                                                type: "number",
                                                readonly: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.product.saleTaxPercentage,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.product,
                                                    "saleTaxPercentage",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "product.saleTaxPercentage",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Percentage Mark Up (%)",
                                          "label-for": "h-password",
                                          "label-cols-md": "4",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "h-Mark",
                                            type: "number",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.markUpPercentage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.product,
                                                "markUpPercentage",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "product.markUpPercentage",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.product.inHouseManufactured === null ||
            _vm.product.inHouseManufactured == false
              ? _c(
                  "form-wizard",
                  {
                    ref: "formWiz",
                    staticClass: "mb-3",
                    attrs: {
                      color: "#B1D06C",
                      title: null,
                      subtitle: null,
                      shape: "square",
                      "finish-button-text": "Finish",
                      "back-button-text": "Previous",
                    },
                    on: { "on-complete": _vm.formSubmitted },
                  },
                  [
                    _c(
                      "tab-content",
                      { attrs: { title: "Details" } },
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Product Name",
                                          "label-for": "mc-Product-name",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Product-name",
                                            type: "text",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.product, "name", $$v)
                                            },
                                            expression: "product.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Product classification",
                                          "label-for": "mc-Product-name",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Product-name",
                                            type: "text",
                                            value: _vm.getTypeNameById(
                                              _vm.product.type
                                            ),
                                            readonly: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Product Code",
                                          "label-for": "mc-Product-Code",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Product-Code",
                                            type: "text",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.code,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.product, "code", $$v)
                                            },
                                            expression: "product.code",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Barcode",
                                          "label-for": "mc-Barcode",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Barcode",
                                            type: "text",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.barcode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.product,
                                                "barcode",
                                                $$v
                                              )
                                            },
                                            expression: "product.barcode",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-for": "mc-stock-threshold",
                                          label: "Unit Of Measure",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-label-group" },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "mc-Barcode",
                                                type: "text",
                                                value: _vm.product.uomName,
                                                readonly: "",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          "label-for": "mc-stock-threshold",
                                          label: "Low Stock Threshold",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-label-group" },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "mc-stock",
                                                type: "text",
                                                readonly: "",
                                              },
                                              model: {
                                                value: _vm.product.lowStock,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.product,
                                                    "lowStock",
                                                    $$v
                                                  )
                                                },
                                                expression: "product.lowStock",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Category",
                                          "label-for": "mc-Category",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Category",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.categoryName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.product,
                                                "categoryName",
                                                $$v
                                              )
                                            },
                                            expression: "product.categoryName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Sub Category",
                                          "label-for": "mc-subCategory",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-subCategory",
                                            value: _vm.product.subCategoryName,
                                            readonly: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Preferred Supplier",
                                          "label-for": "mc-Supplier",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Supplier",
                                            type: "text",
                                            value: _vm.getSupplierNameById(
                                              _vm.product.supplierId
                                            ),
                                            readonly: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "check-button" } },
                                      [_vm._v("Product Status")]
                                    ),
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          checked: "true",
                                          name: "check-button",
                                          switch: "",
                                          disabled: true,
                                        },
                                        model: {
                                          value: _vm.product.isActive,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.product,
                                              "isActive",
                                              $$v
                                            )
                                          },
                                          expression: "product.isActive",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.product.isActive
                                                ? "Enabled"
                                                : "Disabled"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c("CustomFieldsDetails", {
                                      attrs: {
                                        ReadOnlyFields: true,
                                        AdditionalFields:
                                          _vm.product.additionalFields,
                                        ModuleReference: "Product",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mb-2",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "textarea-default" } },
                                      [_vm._v("Product Description")]
                                    ),
                                    _c("b-form-textarea", {
                                      attrs: {
                                        id: "textarea-default",
                                        value: "Lorem",
                                        rows: "5",
                                        readonly: "",
                                      },
                                      model: {
                                        value: _vm.product.description,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.product,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "product.description",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("b-row", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-6" },
                                    [
                                      _vm.product.productImage
                                        ? _c(
                                            "b-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Product Image",
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        "data:image/jpeg;base64," +
                                                        _vm.product
                                                          .productImage,
                                                      width: "250",
                                                      height: "250",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-6" },
                                    [
                                      _vm.product.barcode
                                        ? _c(
                                            "b-col",
                                            [
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    {
                                                      ref: "barcode",
                                                      staticClass:
                                                        "d-flex justify-content-center align-items-center",
                                                    },
                                                    [
                                                      _c(
                                                        "barcode",
                                                        {
                                                          staticClass: "canva",
                                                          attrs: {
                                                            value:
                                                              _vm.product
                                                                .barcode,
                                                            format: "CODE128",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Invalid barcode - Barcode cannot be rendered. "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column justify-content-between",
                                                    },
                                                    [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "w-50",
                                                          attrs: {
                                                            variant: "success",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.downloadBarcode,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Download Barcode"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "w-50",
                                                          attrs: {
                                                            variant: "info",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.printBarcode,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Print Barcode"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "tab-content",
                      { attrs: { title: "Pricing" } },
                      [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                              },
                            },
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Cost Price",
                                          "label-for": "h-number",
                                          "label-cols-md": "4",
                                        },
                                      },
                                      [
                                        _vm.HasPermission(
                                          _vm.PermissionList.Inventory_Finance
                                        )
                                          ? _c("b-form-input", {
                                              attrs: {
                                                id: "h-number",
                                                type: "number",
                                                readonly: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.product.purchasePrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.product,
                                                    "purchasePrice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "product.purchasePrice",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label:
                                            "Selling Price (Tax Exclusive)",
                                          "label-for": "h-Selling",
                                          "label-cols-md": "4",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "h-Mark",
                                            type: "number",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.salePrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.product,
                                                "salePrice",
                                                $$v
                                              )
                                            },
                                            expression: "product.salePrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Sales Tax",
                                          "label-for": "h-Tax",
                                          "label-cols-md": "4",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "h-Mark",
                                            type: "number",
                                            readonly: "",
                                          },
                                          model: {
                                            value:
                                              _vm.product.saleTaxPercentage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.product,
                                                "saleTaxPercentage",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "product.saleTaxPercentage",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Percentage Mark Up (%)",
                                          "label-for": "h-password",
                                          "label-cols-md": "4",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "h-Mark",
                                            type: "number",
                                            readonly: "",
                                          },
                                          model: {
                                            value: _vm.product.markUpPercentage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.product,
                                                "markUpPercentage",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "product.markUpPercentage",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }